import { GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE, CREATE, UPDATE, DELETE, fetchUtils } from 'react-admin';
import { stringify } from 'query-string';
import * as constants from '../constants';

export const API_URL = constants.configuration.BASE_URL;
export const FORM_DATA = 'FORM_DATA';
export const POST_GET_LIST = 'POST_GET_LIST';

/**
 * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
 * @param {String} resource Name of the resource to fetch, e.g. 'posts'
 * @param {Object} params The REST request params, depending on the type
 * @returns {Object} { url, options } The HTTP request parameters
 */
const convertRESTRequestToHTTP = (type: string, resource: string, params: any): any => {
    let url = '';
    const options: any = {
        credentials: 'include',
    };

    /*if (!options.headers) {
        options.headers = new Headers({ 
            Accept: '',
            'X-XSRF-TOKEN': sessionStorage.getItem('csrfToken') as string
             
        });
    }
    options.headers.set('Content-Type', 'application/json')
    options.headers.set('Access-Control-Allow-Origin', '*')
    options.headers.set('Content-Length', 0)
    options.mode = 'cors';
    options.mode = 'no-cors'; */

    switch (type) {
        case GET_LIST: {
            if (params !== undefined) {
                let query: any = {};
                let range: any = [];
                let sort: any = [];
                if (params.pagination !== undefined) {
                    const { page, perPage } = params.pagination;
                    range = [(page - 1) * perPage, page * perPage - 1];
                    query.range = JSON.stringify(range);
                }
                if (params.sort !== undefined) {
                    const { field, order } = params.sort;
                    sort = [field, order];
                    query.sort = JSON.stringify(sort);
                }

                query.filter = JSON.stringify(params.filter);

                url = `${API_URL}/${resource}?${stringify(query)}`;
            } else {
                url = `${API_URL}/${resource}`;
            }
            break;
        }
        case GET_ONE:
            if (params !== undefined) {
                url = `${API_URL}/${resource}/${params.id}`;
            } else {
                url = `${API_URL}/${resource}`;
            }
            options.method = 'GET';
            break;
        case GET_MANY: {
            const query = {
                filter: JSON.stringify({ id: params.ids }),
            };
            url = `${API_URL}/${resource}?${stringify(query)}`;
            break;
        }
        case GET_MANY_REFERENCE: {
            const { page, perPage } = params.pagination;
            const { field, order } = params.sort;
            const query = {
                sort: JSON.stringify([field, order]),
                range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
                filter: JSON.stringify({ ...params.filter, [params.target]: params.id }),
            };
            url = `${API_URL}/${resource}?${stringify(query)}`;
            break;
        }
        case UPDATE:
            url = `${API_URL}/${resource}/${params.id}`;
            options.method = 'PUT';
            options.body = JSON.stringify(params.data);
            break;
        case CREATE:
        case POST_GET_LIST:
            //        const formData = new FormData();
            //  formData.append('agentState', '2');
            url = `${API_URL}/${resource}`;

            options.method = 'POST';
            options.body = JSON.stringify(params.data);
            break;
        case FORM_DATA:
            const formData = new FormData();
            for (var k in params.data) {
                //params.data.hasOwnProperty(k) && params.data[k]
                if (params.data.hasOwnProperty(k)) {
                    formData.append(k, params.data[k]);
                }
            }

            url = `${API_URL}/${resource}`;
            options.method = 'POST';
            options.body = formData;
            break;
        case DELETE:
            url = `${API_URL}/${resource}/${params.id}`;
            options.method = 'DELETE';
            break;
        default:
            throw new Error(`Unsupported fetch action type ${type}`);
    }

    return { url, options };
};

/**
 * @param {Object} response HTTP response from fetch()
 * @param {String} type One of the constants appearing at the top if this file, e.g. 'UPDATE'
 * @param {String} resource Name of the resource to fetch, e.g. 'posts'
 * @param {Object} params The REST request params, depending on the type
 * @returns {Object} REST response
 */
export type IArray = { [key in number | string]: any };

const convertHTTPResponseToREST = (response: any, type: string, _resource: string): object => {
    const { headers, json } = response;
    switch (type) {
        case POST_GET_LIST:
        case GET_LIST:
            var newArray: IArray = [];
            let data = json.data.rows !== undefined ? json.data.rows : json.data;
            Object.keys(data).map(function (key: any) {
                if (typeof data[key] == 'object') {
                    if (data[key].id === undefined) {
                        data[key].id = 0;
                    }
                }

                if (typeof data[key] == 'string' && typeof key == 'string') {
                    var obj: any = { id: 0, key: key, value: data[key] };
                    newArray.push(obj);
                }
            });

            return {
                data: newArray.length == 0 && Object.keys(data).length != 0 ? data : newArray,
                //           data: json.data.map((x : any) => x.id !== undefined ? x : Object.assign({id: 0}, x)),
                total: headers.get('content-range')
                    ? parseInt(
                        headers
                            .get('content-range')
                            .split('/')
                            .pop(),
                        10,
                    )
                    : json.data.rowCount !== undefined
                        ? json.data.rowCount
                        : 0,
            };
        case CREATE:
            if (json.body) {
                const headers = {
                    contentType: 'csv',
                    fileName: json.fileName
                }
                return {
                    data: { data: response.body, headers: headers },
                }
            } else if (json.data) {
                if (Array.isArray(json.data)) {
                    return json;
                }
                return { ...json, data: { ...json.data } };
            } else {
                return { ...json, data: { id: 0 } };
            }
        case GET_ONE:
            //return { ...json, data: json.data ? {...json.data, id: json.data.id !== undefined ? json.data.id : 0} : {...json, id: json.id !== undefined ? json.id : 0} };
            return {
                ...json,
                data: json.data ? { ...json.data, id: json.data.id !== undefined ? json.data.id : 0 } : {},
            };
        default:
            return { ...json, data: json.data };
    }
};

/**
 * @param {string} type Request type, e.g GET_LIST
 * @param {string} resource Resource name, e.g. "posts"
 * @param {Object} payload Request parameters. Depends on the request type
 * @returns {Promise} the Promise for a REST response
 */
export default (type: string, resource: string, params: any = undefined) => {
    const { fetchJson } = fetchUtils;
    const { url, options } = convertRESTRequestToHTTP(type, resource, params);
    return fetchJson(url, options).then((response: any) => convertHTTPResponseToREST(response, type, resource));
};
